import { z } from 'zod'

export const paramsSchema = z.object({
  id: z.string(),
  limit: z.number().int(),
})

export type paramsType = z.infer<typeof paramsSchema>
